function test(regex: string): boolean {
  let re = regex;

  if (regex[0] == '/') {
    re = regex.substr(1, re.length - 4);
  }

  return new RegExp(re, 'gi').test(navigator.userAgent);
}

export const getDeviceClass = (): string => {
  let deviceClass = 'pc';

  if (window?.['__PRELOADED_STATE__']?.[0]?.publicRuntimeConfig?.publicConfig?.deviceClass) {
    return window['__PRELOADED_STATE__'][0].publicRuntimeConfig.publicConfig.deviceClass;
  }

  if (
    test('/((compatible; Googlebot-Mobile/2.1; +http://www.google.com/bot.html))/gi') ||
    (test('/((Android|iPhone))/gi') && test('(compatible.?; Googlebot/2.1.?; +http://www.google.com/bot.html)')) ||
    (test('/((iPhone|Windows Phone))/gi') && test('(compatible; bingbot/2.0; +http://www.bing.com/bingbot.htm)'))
  ) {
    deviceClass = 'mobile-bot';
  } else if (
    test('/((ads|google|bing|msn|yandex|baidu|ro|career|seznam|)bot)/gi') ||
    test('/((baidu|jike|symantec)spider)/gi') ||
    test('/(pingdom)/gi') ||
    test('/(facebookexternalhit)/gi') ||
    test('/(scanner)/gi') ||
    test('/(slurp)/gi') ||
    test('/((web)crawler)/gi')
  ) {
    deviceClass = 'bot';
  } else if (test('ipad')) {
    deviceClass = 'tablet-ipad';
  } else if (test('/(ip(hone|od))/gi')) {
    deviceClass = 'mobile-iphone';
  } else if (test('/(/(android)/gi.*(mobile|mini))/gi')) {
    /* how do we differ between an android phone and an android tablet?
     http://stackoverflow.com/questions/5341637/how-do-detect-android-tablets-in-general-useragent */
    deviceClass = 'mobile-android';
  }
  // /(android 3)/gi/honeycomb was just about tablet-only, and any phones will probably handle a bigger page layout.
  else if (test('android 3')) {
    deviceClass = 'tablet-android';
  } else if (test('/(Opera Mobi)/gi')) {
    /* Opera Mobile */
    deviceClass = 'mobile-smartphone';
  }
  // May very well give false positives towards android tablets. Suggestions welcome.
  else if (test('android')) {
    deviceClass = 'tablet-android';
  } else if (test('/(PlayBook; U; RIM Tablet)/gi')) {
    deviceClass = 'tablet-rim';
  } else if (test('/(hp-tablet.*TouchPad)/gi')) {
    deviceClass = 'tablet-hp';
  } else if (test('/(Kindle/3)/gi')) {
    deviceClass = 'tablet-kindle';
  } else if (test('/(Touch.+Tablet PC)/gi') || test('/(Windows NT [0-9.]+; ARM;)/gi')) {
    deviceClass = 'tablet-microsoft';
  } else if (test('/(Mobile.+Firefox)/gi')) {
    deviceClass = 'mobile-firefoxos';
  } else if (
    test('/(^HTC)/gi') ||
    test('/(Fennec)/gi') ||
    test('/(IEMobile)/gi') ||
    test('/(BlackBerry)/gi') ||
    test('/(BB10.*Mobile)/gi') ||
    test('/(GT-.*Build/GINGERBREAD)/gi') ||
    test('/(SymbianOS.*AppleWebKit)/gi')
  ) {
    deviceClass = 'mobile-smartphone';
  } else if (
    test('/(symbian)/gi') ||
    test('/(^sonyericsson)/gi') ||
    test('/(^nokia)/gi') ||
    test('/(^samsung)/gi') ||
    test('/(^lg)/gi') ||
    test('/(bada)/gi') ||
    test('/(blazer)/gi') ||
    test('/(cellphone)/gi') ||
    test('/(iemobile)/gi') ||
    test('/(midp-2.0)/gi') ||
    test('/(u990)/gi') ||
    test('/(netfront)/gi') ||
    test('/(opera mini)/gi') ||
    test('/(palm)/gi') ||
    test('/(nintendo wii)/gi') ||
    test('/(playstation portable)/gi') ||
    test('/(portalmmm)/gi') ||
    test('/(proxinet)/gi') ||
    test('/(windows ?ce)/gi') ||
    test('/(winwap)/gi') ||
    test('/(eudoraweb)/gi') ||
    test('/(htc)/gi') ||
    test('/(240x320)/gi') ||
    test('/(avantgo)/gi')
  ) {
    deviceClass = 'mobile-generic';
  }

  return deviceClass;
};
